import apiClient from '@/services/api_client';
import { UserModelSpending } from '@/types';

export async function recordDeepResearchRequest(tenantId: string) {
    const url = `/user_usage/deep_research?tenant_id=${tenantId}`;
    return await apiClient.post(url, {});
}

export async function getDailyDeepResearchCount(
    tenantId: string
): Promise<{ count: number; show_info: boolean }> {
    const url = `/user_usage/deep_research/daily_count?tenant_id=${tenantId}`;
    const response = await apiClient.get(url);
    return await response.json();
}

/**
 * Returns the current-period model spending counter, or `null` if the user has
 * not spent anything yet in this period.
 *
 * Throws on transport errors or when the backend cannot resolve a billing
 * period (HTTP 503 → `BillingPeriodUnavailable`). Callers are expected to
 * catch and degrade — see `useModelSpendingStore`.
 */
export async function getUserModelSpending(
    tenantId: string
): Promise<UserModelSpending | null> {
    const url = `/user_usage/model_spending?tenant_id=${tenantId}`;
    const response = await apiClient.get(url);
    return await response.json();
}
